import _ from 'lodash';
import * as pm from "../postMessage";
import platformUtils from 'platformUtils';

const extractSerializable = (obj) => _.omitBy(obj, (e) => _.isFunction(e));
const extractEvents = (obj) => _.pickBy(obj, (e) => _.isFunction(e));
const NEW_DATA_FLOW_EXPERIMENT_NAME = 'sv_newTPANativeDataFlow';

function setComponentProps({controllerId, appDefinitionId, props}) {
    pm.sendMessageToHost(pm.Intent.WIX_CODE_SITE_API, {
        command: pm.MessageTypes.SET_TPA_NATIVE_COMPONENT_PROPS,
        appDefinitionId,
        data: {
            props,
            controllerId
        }
    });
}

function dataPartition(obj) {
    // first level
    const events = extractEvents(obj);
    const serialized = extractSerializable(obj);
    // second level
    _.forEach(serialized, (val, key) => {
        if (_.isObject(val) && !_.isArray(val)) {
            _.assign(events, _.mapKeys(extractEvents(val), (v, k) => `${key}.${k}`));
            _.assign(serialized, {[key]: extractSerializable(val)});
        } else {
            _.assign(serialized, {[key]: val});
        }
    });
    return {serializedData: serialized, events};
}

export function updateControllerData(contextId, currentRMI, controllerDataQuery, data) {
    const scopedRMI = currentRMI.getScopedRMI(controllerDataQuery);
    const controllerId = scopedRMI.getCompIdByDataQuery(controllerDataQuery);
    const currentData = scopedRMI.getData(controllerId) || {};
    const {serializedData, events} = dataPartition(data);
    const eventsInfo = _.mapValues(events, (callback, eventName) => {
        const callbackId = scopedRMI.registerEventCallback({callback, overrideCallbackId: `${controllerId}-${eventName}`});
        return {callbackId, contextId};
    });
    if (platformUtils.isExperimentOpen(NEW_DATA_FLOW_EXPERIMENT_NAME)) {
        setComponentProps({
            controllerId,
            appDefinitionId: scopedRMI.getAppDefinitionId(),
            props: {
                wixCodeProps: serializedData,
                events: eventsInfo
            }
        });
    } else {
        scopedRMI.setData(controllerId, {
            wixCodeProps: _.defaults(serializedData, currentData.wixCodeProps),
            events: _.defaults(eventsInfo, currentData.events)
        });
    }
}


export function handleNativeEvent(RMI, {callbackId, eventArgs}) {
    const eventHandler = RMI.getCallbackById(callbackId);
    if (_.isFunction(eventHandler)) {
        eventHandler(...eventArgs);
    }
}



// WEBPACK FOOTER //
// ./js/modules/privates/utils/nativeComponentUtils.es6